var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBuyNow)?_c('buy-now-button',{attrs:{"for-mobile":_vm.forMobile,"disabled":_vm.disabled || _vm.buyNowDisabled},on:{"confirm":_vm.place_bid}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }